"use client";

import React from "react";

function Overlay({ url, width, className }) {
  if (!url) return null;

  return (
    <div
      className={className}
      style={{
        backgroundImage: `url(${url})`,
        width: `${width || 500}px`,
        height: `${width || 500}px`,
        opacity: 0.5,
      }}
    />
  );
}

export function RandomBackground({ images }) {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 pointer-events-none"
    >
      <Overlay
        url={images?.topLeft?.url}
        width={images?.topLeft?.width}
        className="absolute bg-no-repeat bg-contain top-24 left-24"
      />
      <Overlay
        url={images?.topRight?.url}
        width={images?.topRight?.width}
        className="absolute bg-no-repeat bg-contain top-24 right-24"
      />
      <Overlay
        url={images?.bottomLeft?.url}
        width={images?.bottomLeft?.width}
        className="absolute bg-no-repeat bg-contain bottom-24 left-24"
      />
      <Overlay
        url={images?.bottomRight?.url}
        width={images?.bottomRight?.width}
        className="absolute bg-no-repeat bg-contain bottom-24 right-24"
      />
    </div>
  );
}
